import { c as _c } from "react/compiler-runtime";
import { SideSheetHeader } from "@opensea/ui-kit";
import { ViewWalletHeaderProfileSection } from "./ViewWalletHeaderProfileSection";
export function ViewWalletHeader(t0) {
  const $ = _c(2);
  const {
    address
  } = t0;
  let t1;
  if ($[0] !== address) {
    t1 = <SideSheetHeader><ViewWalletHeaderProfileSection address={address} /></SideSheetHeader>;
    $[0] = address;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}